import React, {useState} from 'react';
import {Router} from "@reach/router";
import Login from "./components/login/Login";
import Landing from "./pages/Landing";
import {ConfigProvider} from "antd";
import moment from "moment";
import localValue from 'moment/locale/tr';
import trTr from 'antd/es/locale/tr_TR.js'
import "./App.css";

moment.locale('tr', localValue)


const AppRoot = () => {

    const [locale] = useState(trTr)

    return (
        <React.Fragment>
            <ConfigProvider locale={locale}>
                <Router>
                    <Login path={'/'}/>
                    <Landing path={'/landing/*'}/>
                </Router>
            </ConfigProvider>
        </React.Fragment>
    )
};
export default AppRoot;
